import { render, staticRenderFns } from "./PatientGenderChart.vue?vue&type=template&id=faf8074c&"
import script from "./PatientGenderChart.vue?vue&type=script&lang=js&"
export * from "./PatientGenderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports